<template>
  <section>
    <div class="header">
      <span>
        <div class="header-box">
          <article class="media">
            <div class="media-content">
              <div class="content">
                <div class="title-text"> Hello, {{ profile.displayName | '' }} </div>
                <div class="title-bold"> Your Libra Wallet QR </div>
              </div>
            </div>
            <div class="media-right">
              <figure class="image is-64x64">
                <img v-if=profile.pictureUrl class="is-rounded" :src=profile.pictureUrl alt="Image">
                <img v-else class="is-rounded" src="https://test.iyawat.com/libra-chatbot/nodejs/images/libra-bg.jpg" alt="img" style="width: 50px;    margin: 0 auto;">
              </figure>
            </div>
          </article>
        </div>
      </span>
    </div>
    <div class="body">
      <span>
        <div class="columns">
          <div class="column is-one-fifth"> </div>
          <div class="column is-three-fifths">
            <div class="row">
              <router-link to="/">
                <img src="libra-logo.png" alt="img" style="width: 80%; max-width: 500px; margin: 0 auto;">
              </router-link>
            </div>
            <div class="row">
              <!-- <img :src="wallet.qrcode_url" alt="img" style="width: 80%; max-width: 500px; margin: 0 auto;"> -->
              <qrcode-vue
                  :value="wallet.accountno"
                  :size="size"
                  background="#FFFFFF"
                  level="H"
                />
            </div>
            <div class="row">
              <b-message
                :closable="false"
                title="Wallet Address: "
                type="is-info"
                has-icon style="overflow-wrap: break-word;"
              >
                <p v-if="!fetched"> Loading .. </p>
                <p v-if="fetched"> {{ wallet.accountno }} </p>
              </b-message>
              <b-message
                :closable="false"
                title="Balance: "
                type="is-info"
                has-icon style="overflow-wrap: break-word;"
              >
                <p v-if="!fetched"> Loading .. </p>
                <p class="balance" v-if="fetched"> {{ wallet.balance | numberWithCommas }} </p>
              </b-message>
            </div>
            <br>
            <div class="button-box">
              <b-button
                icon-left="copy"
                @click="copyAddress"
              >
                Copy To Clipboard
              </b-button><br>
              <social-sharing
                :url="shareUrl"
                :title="shareText"
                :description="shareText"
                :quote="shareText"
                class="card-footer-item share"
                hashtags="Libra,Blockchain,Kulap"
                twitter-user="kulap"
                inline-template
              >
                <div>
                  <network
                    network="facebook"
                    class="share-facebook-btn"
                  >
                    <b-button icon-left="share">
                      Share to Facebook
                    </b-button>
                  </network>
                </div>
              </social-sharing>

              <b-button
                icon-left="share"
                @click="sendMessage"
              >
                Share to Line
              </b-button><br>

              <b-button
                icon-left="arrow-left"
                @click="back"
              >
                Back
              </b-button>
            </div>
          </div>
          <div class="column is-one-fifth"> </div>
        </div>
      </span>
    </div>
    <FooterBar />
  </section>
</template>

<script>
// require styles
import FooterBar from '@/views/Footer'
import QrcodeVue from 'qrcode.vue'
import { mapState, mapActions } from 'vuex'
import { ToastProgrammatic as Toast } from 'buefy'

export default {
  name: 'Receive',
  components: {
    FooterBar,
    QrcodeVue
  },
  data: () => ({
    size: 200,
    fetched: false,
    profile: {
      userId: '',
      displayName: '',
      pictureUrl: '',
      statusMessage: ''
    }
  }),
  filters: {
    numberWithCommas (x) {
      let parts = x.toString().split('.')
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return parts.join('.')
    }
  },
  mounted () {
    setTimeout(() => {
      this.getProfile()
      this.fetched = true
    }, 1000)
  },
  computed: {
    ...mapState({
      wallet: state => state.wallet
    }),
    shareUrl () {
      return `http://nav.cx/2EteS7L`
    },
    shareText () {
      return `Hi there, Check out this Line Libra Wallet!
      Please send Libra coin to me at address :
      ${this.wallet.accountno}`
    }
  },
  methods: {
    ...mapActions({
      updateWallet: 'updateWallet'
    }),
    sendMessage () {
      this.$liff.sendMessages([this.wallet.message[0]])
        .then(function () {
          Toast.open({
            message: 'Message sent to your line',
            type: 'is-success'
          })
        }).catch(function (error) {
          Toast.open({
            message: 'Error sending message: ' + error,
            type: 'is-danger'
          })
        })
    },
    getProfile () {
      let _this = this
      this.$liff.getProfile().then(function (profile) {
        _this.profile = profile
      }).catch(function (error) {
        Toast.open({
          message: 'Error getting profile: ' + error,
          type: 'is-danger'
        })
      })
    },
    back () {
      this.$router.push({ name: 'Home' })
    },
    copyAddress () {
      this.copyText(this.wallet.accountno)
    },
    copyText (text) {
      this.$copyText(text).then((e) => {
        Toast.open({
          message: 'Address Copied',
          type: 'is-success'
        })
      }, (e) => {
        Toast.open({
          message: 'Cannot copy address',
          type: 'is-danger'
        })
      })
    },
    copyPublicLink () {
      this.copyText(this.shareUrl)
    }
  }
}
</script>

<style lang="css">
@import 'https://fonts.googleapis.com/css?family=Kanit|Prompt';

  main, html, body {
    font-family: 'Prompt', sans-serif;
    overflow-x: none;
    -webkit-overflow-scrolling: touch;
    background-color: #F4F4F4;
  }
  .header {
    overflow:hidden;
  }
  .header-box {
    background-color: rgb(76, 0, 114);
    border-radius: 0;
    padding: 5% 5% 5% 5%;
  }
  .title-bar {
    background-color: rgb(76, 0, 114);
  }
  .title-text {
    font-size: 20px;
    font-weight: 500;
    color: #fff;
    letter-spacing: .5px;
  }
  .title-bold{
    font-weight: 400;
    font-size: 16px;
    color: rgba(255, 255, 255, 0.801);
    letter-spacing: .5px;
  }

</style>

<style lang="scss" scoped>
  .button-box {
  margin-top: 25px;
  padding: 0 30px;
  button {
    width: 100%;
    height: 60px;
    margin-bottom: 20px;
  }
  .balance {
    font-size: 30px;
    font-weight: bold;
    vertical-align: middle;
  }
}
</style>
<style lang="scss">
.card-footer-item {
  padding: 0 !important;
  border: 0 !important;
}
.share-facebook-btn {
  width: 100%;
  button {
    width: 100%;
    height: 60px;
    margin-bottom: 20px;
  }
}
</style>
